import { create } from "zustand";

const LogoStore = create((set) => ({
  selectedIssue: null,

  setSelectedLogo: (l) =>
    set({ selectedLogo: l }),

  clearSelectedLogo: () =>
    set({ selectedLogo: null }),
}));

export default LogoStore;